import { Injectable } from '@angular/core';
import { LogConfigService, LogWriter, Settings } from 'common-components';
import { LogLevel } from 'common-components';
import { BackendWriter } from './backend-writer';
import { HttpClient } from '@angular/common/http';

export function LogConfigServiceLoaderFactory(http: HttpClient): Settings {
    return {logConfigService: new PublicLogConfigService(http)};
}

@Injectable()
export class PublicLogConfigService implements LogConfigService {

    constructor(private httpClient: HttpClient) {
    }
    public getLogLevel(): LogLevel {
        return LogLevel.Error;
    }
    public getLogWriters(): LogWriter[] {
        return [
            new BackendWriter(this.httpClient)
        ];
    }
}
